// CPAYMENT-1530: must be the FIRST import so Sentry.init runs before any other module
// (App, i18n, api.ts) is evaluated and can capture errors from the very start of the bundle.
import './analytics/sentryBoot'
import isPropValid from '@emotion/is-prop-valid'
import ReactDOM from 'react-dom/client'
import { StyleSheetManager } from 'styled-components'
import App from './App'
import './styles/index.scss'
import './i18n'
import { initAnalytics } from './analytics'

// CPAYMENT-1480 diagnostic beacon: proves the JS bundle executed. Remove after analysis.
;(window as any).__b?.('3-bundle-exec')

initAnalytics()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <StyleSheetManager shouldForwardProp={(prop) => isPropValid(prop)}>
    <App />
  </StyleSheetManager>
)

;(window as any).__b?.('4-react-render')
